import { authHeader } from '../_helpers';
import httpClient from '../utils/http'

export const userService = {
  login,
  employeeLogin,
  logout,
  register,
  getAll,
  getById,
  update,
  delete: _delete,
  token
};

function login(companyCode, userId, password) {
  const url = '/login';
  const payload = {
    companyCode: companyCode,
    userId: userId,
    password: password
  };
  // const config = {
  //   headers: {
  //     'content-type': 'application/json'
  //   }
  // };

  console.log(`httpClient ${httpClient}`)


  return httpClient
    .post(url, payload)
    .then(handleResponseAsync)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.profile) {
        delete user.profile.token;
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user.profile));
      }

      return user;
    }).catch(ex => {
      console.log()
    });
}

function token(companyCode, userId, password) {
  const url = '/token';
  const payload = {
    companyCode: companyCode,
  };
  // const config = {
  //   headers: {
  //     'content-type': 'application/json'
  //   }
  // };

  return httpClient
    .post(url, payload)
    .then(handleResponseAsync)
    .then(user => {
      // login successful if there's a jwt token in the response
      // if (user.profile) {
      //   delete user.profile.token;
      //   // store user details and jwt token in local storage to keep user logged in between page refreshes
      //   localStorage.setItem('user', JSON.stringify(user.profile));
      // }

      return user;
    }).catch(ex => {
      // console.log()
    });
}

function employeeLogin(userId) {
  const url = '/employeeLogin';
  const payload = {
    userId: userId,
  };

  return httpClient
    .post(url, payload)
    .then(handleResponseAsync)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.profile) {
        delete user.profile.token;
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user.profile));
      }

      return user;
    }).catch(ex => {
      console.log()
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/users`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/users/${id}`, requestOptions).then(handleResponse);
}

function register(user) {
  const url = '/api/users/register';
  // const config = {
  //   headers: {
  //     'content-type': 'application/json'
  //   }
  // };
  return httpClient.post(url, user).then(handleResponseAsync);
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(`/users/${user.id}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`/users/${id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  // handle 500, 404 error
  if (
    response.status === 500 ||
    response.status === 503 ||
    response.status === 404
  ) {
    return Promise.reject(response.statusText);
  }
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        window.location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    if (typeof data.ok === 'boolean' && !data.ok) {
      return Promise.reject(data.text);
    }
    return data;
  });
}

const handleResponseAsync = response => {
  if (response) {
    const resp = response.data;

    if (resp) {
      const ok = resp.ok;
      if (ok) {
        return resp;
      } else {
        const error = resp.message || resp.statusText;
        throw new Error(error);
      }
    } else {
      const error = resp.statusText;
      throw new Error(error);
    }
  } else {
    throw new Error('server error');
  }
};
